import React from "react"
import PropTypes from 'prop-types'
import { Link, StaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"


const allEmployees = () => (
  <StaticQuery
    query={graphql`
    query allEmployeesArchive{
        allMarkdownRemark(filter: {fileAbsolutePath: {regex: "/employees/"  }}){
          edges{
            node{
              html
              frontmatter{
                path
                nafn
                starfsvid
                postur
                simi
                image{
                  childImageSharp {
                    fluid(maxWidth: 50) {
                      src
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={({allMarkdownRemark}) => (
          <section class="section">
          <h1 class="title">Starfsmenn</h1>
            <div class="columns is-multiline">
            {allMarkdownRemark.edges.map(edge => (
            <>
                <div class="column is-one-third">
                    <div class="box">
                        <div class="media">
                        <div class="media-left">
                            <figure class="image is-48x48">
                            <img src={edge.node.frontmatter.image.childImageSharp.fluid.src} alt="Placeholder image"></img>
                            </figure>
                        </div>
                        <div class="media-content disable-scroll-employee">
                            <p class="title is-4">{edge.node.frontmatter.nafn}</p>
                            <p class="subtitle is-6">{edge.node.frontmatter.starfsvid}</p>
                        </div>
                        </div>

                        <br></br>
                        <div class="content">
                        <strong>Póstur:</strong> {edge.node.frontmatter.postur}<br></br>
                        <strong>Simi:</strong> {edge.node.frontmatter.simi}<br></br><br></br>
                        <div class="button" key={edge.node.frontmatter.path}>
                        <Link to={`/about/${edge.node.frontmatter.path}`}>Menntun og reynsla</Link>
                        </div>
                        </div>
                    </div>
                </div>
              </>
            ))}
            </div>
          </section>
    )}
  />
)

export default allEmployees

